import MicroModal from 'micromodal'

export default function () {
    // https://micromodal.now.sh/

    const modals = document.querySelectorAll('.modal');
    const modalButtons = document.querySelectorAll('.js-modalLink');

    if (modalButtons.length > 0) {

        Array.prototype.slice.call(modals).forEach(modal => {
            document.body.appendChild(modal) // move them to the footer since they need to overlay the whole page
            modal.querySelector(`.Icon--close`).addEventListener(`click`, (e) => {
                e.preventDefault() // prevent jumping to the top when clicking close
            })
        })

        MicroModal.init({
            openClass: 'is-open', // [5]
            disableScroll: false, // [6]
            disableFocus: true, // [7]
            awaitOpenAnimation: false, // [8]
            awaitCloseAnimation: true, // [9]
            debugMode: false // [10]
        })

        Array.prototype.slice.call(modalButtons).forEach(button => {
            button.addEventListener('click', function (e) {
                e.preventDefault() // prevent jumping to the top when clicking open
            })
        })
    }
}
